import { render, staticRenderFns } from "./CLogo.vue?vue&type=template&id=113e037a"
import script from "./CLogo.vue?vue&type=script&lang=js"
export * from "./CLogo.vue?vue&type=script&lang=js"
import style0 from "./CLogo.vue?vue&type=style&index=0&id=113e037a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
